import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';
import { ApiService } from '@/services/api.service';

export function useFetchData(
  queryKey: string[],
  endpoint: string,
  config: AxiosRequestConfig<any> = {},
  isPost: boolean = false,
  postData: Record<string, any> | null = null,
  queryOptions: Omit<UseQueryOptions<any, unknown, any, string[]>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery(
    queryKey,
    async () => ApiService.fetchData(endpoint, isPost ? 'POST' : 'GET', postData, config),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  );
}
